import { SurchargingConfigSection } from "@/apidtos";
import { useRootLoaderData } from "@/root";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";

interface PaymentSurchargeDisclosureProps {
  surchargePercent?: number | null;
}

export const PaymentSurchargeDisclosure: React.FC<PaymentSurchargeDisclosureProps> = ({ surchargePercent }) => {
  const { config } = useRootLoaderData();
  const surchargingConfig = config?.Surcharging as SurchargingConfigSection | undefined;

  if (!surchargingConfig?.SurchargeEnabled) {
    return null;
  }

  if (surchargingConfig.PaymentModalDisclosureFallback) {
    return (
      <div className="text-sm text-muted-foreground mt-2">
        {surchargingConfig.PaymentModalDisclosureFallback}
      </div>
    );
  }

  return (
    <div className="text-sm text-muted-foreground mt-2">
      Surcharge will be shown after clicking Calculate Surcharge.
    </div>
  );
};

registerExtension("_site.payments.message", PaymentSurchargeDisclosure, "PaymentSurchargeDisclosure");

